$(() => {
  $('[data-action="set-profile-image"]').click(e => {
    var image_url = $(e.target).data('image-url');
    var original_image_url = $(e.target).data('original-image-url');
    var influencer_id = $(e.target).data('influencer-id');
    var influencer_name = $(e.target).data('influencer-name');

    var modalSource = $('[data-template="set-profile-image-modal"]').html();
    var tpl = Handlebars.compile(modalSource);
    var view = tpl({
      original_image_url: original_image_url,
      image_url: image_url,
      influencer_id: influencer_id,
      influencer_name: influencer_name
    });
    var modalWindow = modal.window(view);

    modalWindow.onDone(() => {
      $('[data-form="set-profile-image"]').submit();
    });

    modalWindow.show();
  });

  $('[data-action="set-profile-image"]').hover(
    (e) => {
      $(e.target).removeClass('opacity-0').addClass('opacity-50');
    },
    (e) => {
      $(e.target).removeClass('opacity-50').addClass('opacity-0');
    }
  )
});
